'use client';

import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { styleBlockFullWidth } from '@/ui/segments/landing/styles';
import { useMenuHeight } from '@/ui/segments/landing/utils.client';
import { classNames } from '@/util/utils';
import FeatureBloc from './feature-bloc';
import PlanHeader from './plan-header';
import type { ContentForPricing } from '@/services/sanity/api/get-pricing-features';
import styles from './small-screen.module.css';
interface SmallScreenProps {
  className?: string;
  data: ContentForPricing | null;
}
export default function SmallScreen(t0) {
  const $ = _c(26);
  const {
    className,
    data
  } = t0;
  const [currentPlanIndex, setCurrentPlanIndex] = React.useState(0);
  const menuHeight = useMenuHeight();
  if (!data) {
    return null;
  }
  const {
    plans,
    features
  } = data;
  const currentPlan = plans[currentPlanIndex];
  let t1;
  if ($[0] !== className) {
    t1 = classNames(className, styles.smallScreen, styleBlockFullWidth);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = `${menuHeight}px`;
  let t3;
  if ($[2] !== t2) {
    t3 = {
      "--custom-menu-height": t2
    };
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== currentPlanIndex || $[5] !== plans) {
    let t5;
    if ($[7] !== currentPlanIndex) {
      t5 = (plan, index) => <button type="button" key={plan.id} disabled={index === currentPlanIndex} onClick={() => setCurrentPlanIndex(index)}>{plan.title}</button>;
      $[7] = currentPlanIndex;
      $[8] = t5;
    } else {
      t5 = $[8];
    }
    t4 = plans.map(t5);
    $[4] = currentPlanIndex;
    $[5] = plans;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[9] !== t3 || $[10] !== t4) {
    t5 = <header style={t3}>{t4}</header>;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== currentPlan) {
    t6 = <PlanHeader plan={currentPlan} />;
    $[12] = currentPlan;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== currentPlan || $[15] !== features) {
    let t8;
    if ($[17] !== currentPlan) {
      t8 = bloc => <FeatureBloc key={bloc.title} bloc={bloc} plan={currentPlan} />;
      $[17] = currentPlan;
      $[18] = t8;
    } else {
      t8 = $[18];
    }
    t7 = features.map(t8);
    $[14] = currentPlan;
    $[15] = features;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[19] !== t6 || $[20] !== t7) {
    t8 = <article className={styleBlockFullWidth}>{t6}{t7}</article>;
    $[19] = t6;
    $[20] = t7;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] !== t1 || $[23] !== t5 || $[24] !== t8) {
    t9 = <div className={t1}>{t5}{t8}</div>;
    $[22] = t1;
    $[23] = t5;
    $[24] = t8;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  return t9;
}